export default __webpack_public_path__ + "static/media/tablehide.0b29a64b.svg";